import { makeAutoObservable } from 'mobx';
import { EmailMessageService } from './service';
import { toast } from 'react-toastify';

class EmailMessageStore {
  constructor() {
    makeAutoObservable(this);
  }
  

  handleReadMail =  async (SearchValue:any,pagenum:number) => {
    try {
      const [readMailResponse, readMailCount] = await Promise.all([
        EmailMessageService.readMail(SearchValue, pagenum, 5),
        this.mailCountHandler(SearchValue, true)
      ]);

      return [readMailResponse.data, readMailCount];
    } catch (error) {
      toast.error('handleReadMail Failed...');
    }
  }

   handleUnreadMail=async(SearchValue:any,pagenum:number)=> {
    try {
      const [unreadMailResponse, unreadMailCount] = await Promise.all([
        EmailMessageService.unReadMail(SearchValue, pagenum, 5),
        this.mailCountHandler(SearchValue, false)
      ]);

      return [unreadMailResponse.data, unreadMailCount];
    } catch (error) {
      toast.error('handleUnreadMail Failed...');
    }
  }

   mailCountHandler=async(item:string, condition:boolean) =>{
    try {
      const response = condition
        ? await EmailMessageService.readMailCount(item)
        : await EmailMessageService.unReadMailCount(item);

      return response.data;
    } catch (error) {
      toast.error('mailCountHandler Failed...');
    }
  }

   mailSearchHandler = async (item:any,pageNumber:number,pageSize:number)=>{
    try {
      const params = {
        item: item,
        PageNumber: pageNumber,
        PageSize: pageSize
      }
   const Response = await EmailMessageService.emailSearchAPI(params);
   return Response.data;
    } catch (error) {
      console.log('mailSearchHandler Failed...')
    }
   }
   checkedMail = async(id:string)=>{
try {
  const response = await EmailMessageService.EmailRead(id);
   return response;
} catch (error) {
  console.log('checkedMail Failed...')
}
   }
   HandlereadMailSortData = async(headerData:any,OrderDirection:boolean,page:number)=>{
    try {
     const response =  await EmailMessageService.readMailSort(headerData,OrderDirection,page,5)
     return response.data;
    } catch (error) {
      console.log('sort Failed...')
    }
   }
   HandleunReadMailSortData = async(headerData:any,OrderDirection:boolean,page:number)=>{
    try {
     const response = await EmailMessageService.unReadMailSort(headerData,OrderDirection,page,5)
      return response.data;
    } catch (error) {
      console.log('sort Failed...')
    }
   }
}

export default EmailMessageStore;
